import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Brain, BarChart, Calendar, ShoppingBag, MessageCircle } from 'lucide-react';
export function ProductExperience() {
  const features = [{
    icon: <Brain className="w-5 h-5 text-charcoal" data-id="element-260" />,
    title: 'AI-Tailored Wellness Plans',
    desc: 'Intelligent pathways that adapt to your evolving health data and goals.'
  }, {
    icon: <BarChart className="w-5 h-5 text-charcoal" data-id="element-261" />,
    title: 'Personal Health Analytics',
    desc: 'A beautiful, intuitive dashboard to track your progress and outcomes.'
  }, {
    icon: <Calendar className="w-5 h-5 text-charcoal" data-id="element-262" />,
    title: 'Seamless Booking',
    desc: 'Frictionless scheduling with our vetted network of practitioners.'
  }, {
    icon: <ShoppingBag className="w-5 h-5 text-charcoal" data-id="element-263" />,
    title: 'Curated Marketplace',
    desc: 'Exclusive access to premium wellness services and products.'
  }, {
    icon: <MessageCircle className="w-5 h-5 text-charcoal" data-id="element-264" />,
    title: 'Private Community Layer',
    desc: 'Connect with peers in a secure, moderated, and supportive environment.'
  }];
  return <Section background="ivory" data-id="element-265">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-266">
        <div className="lg:col-span-5" data-id="element-267">
          <FadeIn data-id="element-268">
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6 leading-tight" data-id="element-269">
              Designed for Precision, <br data-id="element-270" />
              <span className="italic text-charcoal/60" data-id="element-271">Built for Care</span>
            </h2>
            <p className="text-lg text-charcoal/70 mb-8" data-id="element-272">
              Not just features — these are the capabilities of a premium
              ecosystem designed to anticipate and serve your wellness needs
              seamlessly.
            </p>
          </FadeIn>
        </div>

        <div className="lg:col-span-7" data-id="element-273">
          <div className="space-y-4" data-id="element-274">
            {features.map((feature, idx) => <FadeIn key={idx} delay={idx * 150} data-id="element-275">
                <div className="group flex items-start p-6 rounded-2xl transition-all duration-300 hover:bg-white hover:shadow-lg hover:shadow-purple-200/40 border border-transparent hover:border-purple-200" data-id="element-276">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-6 flex-shrink-0 group-hover:bg-purple-200 transition-colors" data-id="element-277">
                    {feature.icon}
                  </div>
                  <div data-id="element-278">
                    <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-279">
                      {feature.title}
                    </h3>
                    <p className="text-charcoal/60 leading-relaxed" data-id="element-280">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </Section>;
}